(function () {
  function init(root) {
    root.querySelectorAll('[data-fg-buy]').forEach(function (buy) {
      if (buy.dataset.ready) return;
      buy.dataset.ready = 'true';
      var select = buy.querySelector('[data-fg-variant]');
      var radios = buy.querySelectorAll('[data-fg-bundle]');
      var dataNode = buy.querySelector('[data-fg-variants]');
      if ((!select && !radios.length) || !dataNode) return;
      var data;
      try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }
      function update(id) {
        var v = data.variants.find(function (item) { return String(item.id) === String(id); });
        if (!v) return;
        if (select) select.value = String(v.id);
        radios.forEach(function (radio) { radio.checked = String(radio.value) === String(v.id); radio.closest('[data-fg-bundle-card]').classList.toggle('is-selected', radio.checked); });
        buy.querySelector('[data-fg-price]').textContent = v.price;
        var compare = buy.querySelector('[data-fg-compare]');
        compare.hidden = !v.sale; compare.textContent = v.compare;
        var savings = buy.querySelector('[data-fg-saving]');
        savings.hidden = !v.sale; savings.textContent = v.discount + ' saved';
        buy.querySelector('[data-fg-submit]').disabled = !v.available;
        buy.querySelector('[data-fg-label]').textContent = v.available ? data.label : 'Sold Out';
      }
      if (select) select.addEventListener('change', function () { document.dispatchEvent(new CustomEvent('forge:variant', { detail: { id: select.value } })); });
      radios.forEach(function (radio) { radio.addEventListener('change', function () { if (radio.checked) document.dispatchEvent(new CustomEvent('forge:variant', { detail: { id: radio.value } })); }); });
      document.addEventListener('forge:variant', function (event) { update(event.detail.id); });
    });
    root.querySelectorAll('[data-fg-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      var track = gallery.querySelector('[data-fg-track]');
      if (!track) return;
      var thumbs = gallery.querySelectorAll('[data-fg-slide]');
      thumbs.forEach(function (button) {
        button.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * Number(button.dataset.fgSlide), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
      });
      track.addEventListener('scroll', function () {
        var current = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        thumbs.forEach(function (button, index) { button.setAttribute('aria-pressed', String(index === current)); });
      }, { passive: true });
    });
    var sticky = document.querySelector('[data-fg-sticky]');
    if (sticky && !sticky.dataset.ready && 'IntersectionObserver' in window) {
      sticky.dataset.ready = 'true';
      var hero = document.querySelector('.fg-hero'), offer = document.getElementById('offer');
      if (hero && offer) {
        var heroPassed = false, offerVisible = false;
        function paint() { var visible = heroPassed && !offerVisible; sticky.hidden = !visible; document.body.classList.toggle('fg-sticky-space', visible && window.innerWidth <= 800); }
        new IntersectionObserver(function (entries) { heroPassed = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0; paint(); }).observe(hero);
        new IntersectionObserver(function (entries) { offerVisible = entries[0].isIntersecting; paint(); }).observe(offer);
        window.addEventListener('resize', paint);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
